//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import AQButton from "@/components/Generics/AQButton/AQButton.vue";
import AQDialog from "@/components/Generics/AQDialog/AQDialog.vue";
import AQBadge from "@/components/Generics/AQBadge/AQBadge.vue";

import { date } from "quasar";
import { mapActions, mapGetters } from "vuex";
import CreateDelegationModal from "./createDelegationModal.vue";

export default {
    name: "TasksDelegation",
    components: {
        AQButton,
        CreateDelegationModal,
        AQDialog,
        AQBadge
    },
    data() {
        return {
            openDelegationModal: false,
            showCancelDialog: false,
            fromEdit: false,
            today: "",
            rejectDelegationDlg: false,
            delegationsList: [],
            currentDelegation: {},
            delegationDetails: {
                startDate: "",
                endDate: "",
                delegatedUser: "",
                isImmediate: false,
                status: ""
            }
        };
    },
    computed: {
        ...mapGetters("userProfile", ["getUserId"]),
        computingExistingDelegation() {
            return this.$t("userProfile.tasksDelegation.delegationText", {
                startDate: date.formatDate(this.delegationDetails.startDate, "DD.MM.YYYY"),
                endDate: date.formatDate(this.delegationDetails.endDate, "DD.MM.YYYY"),
                delegatedUser: this.delegationDetails.delegatedUser
            });
        },
        computingCancelBodyMsg() {
            let msg = "";
            if (this.today >= this.delegationDetails.startDate) {
                msg = this.$t("userProfile.tasksDelegation.cancelDelegationStartedBody",
                    { startDate: date.formatDate(this.delegationDetails.startDate, "DD.MM.YYYY"), delegatedUser: this.delegationDetails.delegatedUser });
            } else {
                msg = this.$t("userProfile.tasksDelegation.cancelDelegationBody", {
                    startDate: date.formatDate(this.delegationDetails.startDate, "DD.MM.YYYY"),
                    endDate: date.formatDate(this.delegationDetails.endDate, "DD.MM.YYYY"),
                    delegatedUser: this.delegationDetails.delegatedUser
                });
            }
            return msg;
        }
    },
    created() {
        this.getToday();
        this.getDelegation(this.getUserId).then(data => {
            const [first] = data || [];
            if (first) {
                this.delegationDetails.startDate = first.startDate;
                this.delegationDetails.endDate = first.endDate;
                this.delegationDetails.delegatedUser = first.delegateUsername;
                this.delegationDetails.isImmediate = first.isImmediate;
                this.delegationDetails.status = first.status;
            }
        });
        this.actDelegationsForUser(this.getUserId).then(data => {
            this.delegationsList = data.data.filter(item => item.status !== "REJ");
        });
    },
    methods: {
        ...mapActions("userProfile", ["getDelegation", "cancelDelegation", "actDelegationsForUser", "actAcceptRejectDelegation"]),
        getDelegationData(data) {
            this.delegationDetails.startDate = data.payload.startDate;
            this.delegationDetails.endDate = data.payload.endDate;
            this.delegationDetails.isImmediate = data.payload.isImmediate;
            this.delegationDetails.delegatedUser = data.delegatedUserName;
            if (data.payload.status) {
                this.delegationDetails.status = data.payload.status;
            }
        },
        getToday() {
            const currentDate = new Date();
            this.today = `${currentDate.getFullYear()
            }-${
                this.formatDate(currentDate.getMonth() + 1)
            }-${
                this.formatDate(currentDate.getDate())}`;
        },
        formatDate(value) {
            return value < 10 ? `0${value}` : value;
        },
        dialogConfirmAction(event) {
            if (event === "ok") {
                this.cancelDelegation().then(() => {
                    this.delegationDetails.startDate = "";
                    this.delegationDetails.endDate = "";
                    this.delegationDetails.delegatedUser = "";
                    this.delegationDetails.status = "";
                    this.delegationDetails.isImmediate = false;
                    this.$toast.showNotify({
                        type: "success",
                        message: this.$t("userProfile.delegationModal.delegationCanceled"),
                        timeout: 500
                    });
                });
            }
        },
        editDelegation() {
            this.openDelegationModal = true;
            this.fromEdit = true;
        },
        newDelegation() {
            this.openDelegationModal = true;
            this.fromEdit = false;
        },
        acceptedDelegation(item) {
            this.actAcceptRejectDelegation({ id: item.id, status: "ACC" }).then(() => {
                item.status = "ACC";
                this.$toast.showNotify({
                    type: "success",
                    message: this.$t("userProfile.tasksDelegation.successfullyAccepted")
                });
            });
        },
        rejectDelegation(item) {
            this.actAcceptRejectDelegation({ id: item.id, status: "REJ" }).then(() => {
                item.status = "REJ";
                this.delegationsList = this.delegationsList.filter(elem => elem.id !== item.id);
            });
        },
        formatDelegationDate(delegationDate) {
            return date.formatDate(delegationDate, "DD.MM.YYYY");
        },
        delegationBadgeText(status) {
            let badgeText = this.$t("userProfile.tasksDelegation.pending");
            if (status === "ACC") {
                badgeText = this.$t("userProfile.tasksDelegation.accepted");
            } else if (status === "REJ") {
                badgeText = this.$t("userProfile.tasksDelegation.rejected");
            }
            return badgeText;
        },
        delegationBadgeType(status) {
            let badgeType = "pending";
            if (status === "ACC") {
                badgeType = "accepted";
            } else if (status === "REJ") {
                badgeType = "rejected";
            }
            return badgeType;
        }
    }
};
